<template lang="html">
  <div :class="['frame-modal', { 'active': isActive }]">
    <div class="modal-bar">
      <div class="modal-bar-content">
        <slot name="modal-title" />
      </div>
    </div>
    <slot name="modal-content" />
  </div>
</template>
<script>
export default {
  name: 'ModalSide',
  props: {
    value: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      test: ''
    }
  },
  computed: {
    'isActive': {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    'isActive'(newItem) {
      if (newItem === true) {
        document.querySelector('html').style.overflowY = 'hidden'
      } else {
        document.querySelector('html').style.overflowY = 'scroll'
      }
    }
  }
}
</script>
